document.addEventListener('DOMContentLoaded', function () {
    const popup = document.querySelector('.ebook-popup-overlay');

    // If no popup exists on the page, exit
    if (!popup) return;

    function openPopup(e) {
        e.preventDefault();
        popup.classList.add('is-visible');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }

    function closePopup() {
        popup.classList.remove('is-visible');
        document.body.style.overflow = '';
    }

    // Bind all triggers
    // Use event delegation or querySelectorAll for existing buttons
    // Using .js-ebook-popup-trigger class allows buttons anywhere to work
    document.querySelectorAll('.js-ebook-popup-trigger').forEach(btn => {
        btn.addEventListener('click', openPopup);
    });

    // Handle popup closure
    popup.addEventListener('click', function (e) {
        if (e.target === popup) {
            closePopup();
        }
    });

    const closeBtn = popup.querySelector('.ebook-popup-close');
    if (closeBtn) {
        closeBtn.addEventListener('click', closePopup);
    }
});
